export default "__VITE_ASSET__L6FO3Q2K__"